export default function initializeSocketOpts(socketUrl, namespace) {
    const opts = {};
    socketUrl = new URL(socketUrl);
    const baseUrl = `${socketUrl.protocol}//${socketUrl.hostname}${socketUrl.port ? ':' + socketUrl.port : ''}`;
    namespace = new URL(namespace, baseUrl).toString();
    let path = `${socketUrl.pathname}`;
    if (path !== '/') {
        opts.path = path;
    }
    return {
        namespace,
        opts,
    };
}